// Shared category-management i18n keys (used by CategoryListing).
// Page-level keys live under `CategoryListing.*`.

export const categoryDict: Record<string, [en: string, th: string]> = {
  // ── Page-level keys (CategoryListing) ────────────────────
  "CategoryListing.pageTitle":   ["Categories", "หมวดหมู่"],
  "CategoryListing.breadcrumb":  ["Categories", "หมวดหมู่"],
  "CategoryListing.search":      ["Search categories...", "ค้นหาหมวดหมู่..."],
  "CategoryListing.filter.type": ["Type", "ประเภท"],
  "CategoryListing.filter.status": ["Status", "สถานะ"],
  "CategoryListing.modal.add":   ["Add Category", "เพิ่มหมวดหมู่"],
  "CategoryListing.modal.edit":  ["Edit Category", "แก้ไขหมวดหมู่"],
  "CategoryListing.label.name":  ["Name", "ชื่อ"],
  "CategoryListing.label.type":  ["Type", "ประเภท"],
  "CategoryListing.label.subCategories": ["Sub Categories", "หมวดหมู่ย่อย"],
  "CategoryListing.label.description":   ["Description", "คำอธิบาย"],
  "CategoryListing.label.sortOrder":     ["Sort Order", "ลำดับการแสดงผล"],
  "CategoryListing.label.active":        ["Active", "เปิดใช้งาน"],
  "CategoryListing.placeholder.type":    ["Select type", "เลือกประเภท"],
  "CategoryListing.placeholder.name":    ["Category name", "ชื่อหมวดหมู่"],
  "CategoryListing.subCategories.empty":  ["No sub categories yet.", "ยังไม่มีหมวดหมู่ย่อย"],
  "CategoryListing.subCategories.hint":   ["Sub categories here will be used in Wine form dropdown.", "หมวดหมู่ย่อยที่นี่จะใช้ใน dropdown ของฟอร์มไวน์"],

  // ── Filter option labels (user-facing choices) ──────────
  "CategoryListing.status.active":   ["Active", "เปิดใช้งาน"],
  "CategoryListing.status.inactive": ["Inactive", "ปิดใช้งาน"],

  // ── Table column headers ───────────────────────────────
  "CategoryListing.column.name":          ["Name", "ชื่อ"],
  "CategoryListing.column.subCategories": ["Sub Categories", "หมวดหมู่ย่อย"],
  "CategoryListing.column.wines":         ["Wines", "ไวน์"],
  "CategoryListing.column.status":        ["Status", "สถานะ"],

  // ── Misc ───────────────────────────────────────────────
  "CategoryListing.subCategories.more": ["+{count} more", "+{count} อื่น ๆ"],
};
